import polyglotI18nProvider from 'ra-i18n-polyglot'
import { TranslationMessages } from 'react-admin'

import { frMessages } from './../i18n/fr'

export const i18nProvider = polyglotI18nProvider(
  () => frMessages as unknown as TranslationMessages | Promise<TranslationMessages>,
  'fr',
)
